import React, { Component } from "react";
import { connect } from "react-redux";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";

import PromotionActionButton from "./PromotionActionButton";
import { cssNumber } from "jquery";

export class PromoItem extends Component {
  state = {
    anchorEl: null,
  };

  getCouponText(promo, language) {
    const { settings } = this.props;
    if (language === "english" && promo.discount_description)
      return promo.discount_description;
    else if (language === "arabic" && promo.ar_discount_description)
      return promo.ar_discount_description;
    else if (promo.discount_type === "percent") {
      if (language === "english") return `Get ${promo.discount_amount}% off`;
      else return ` احصل على خصم بقيمة  % ${promo.discount_amount}`;
    } else if (promo.discount_type === "fixed") {
      if (language === "english")
        return `Get ${promo.discount_amount} ${
          settings.currency_iso === "SAR" ? "SAR" : settings.currency_english
        } off`;
      else
        return ` احصل على خصم بقيمة   ${promo.discount_amount} ${
          settings.currency_iso === "SAR" ? "رس" : settings.currency_local
        }`;
    } else if (promo.discount_type === "delivery") {
      if (language === "english") return `Free delivery`;
      else return `توصيل مجاني`;
    }
  }

  getContrastYIQ = (hexcolor) => {
    if (!hexcolor) return "black";
    var r = parseInt(hexcolor.substring(1, 3), 16);
    var g = parseInt(hexcolor.substring(3, 5), 16);
    var b = parseInt(hexcolor.substring(5, 7), 16);
    var a = parseInt(hexcolor.substring(7, 9), 16);
    if (a < 50 && !!a) return "black";
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? "black" : "white";
  };

  getExpiryDates = (date) => {
    const targetDate = new Date(date);
    const currentDate = new Date();

    const diffInMs = targetDate - currentDate;

    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

    return diffInDays > 0 ? diffInDays : 0;
  };

  render() {
    const { language, promo, is_coupon } = this.props;
    return (
      <div
        className="card"
        style={{
          width: "100%",
          minHeight:
            180 +
            (promo.show_remaining ? 20 : 0) +
            (promo.show_expiry ? 20 : 0),
          maxHeight:
            180 +
            (promo.show_remaining ? 20 : 0) +
            (promo.show_expiry ? 20 : 0),
          overflow: "hidden",
          backgroundColor: promo.background_color,
          color: this.getContrastYIQ(promo.background_color),
        }}
      >
        <div
          style={{
            textAlign: language == "english" ? "left" : "right",
            direction: language == "arabic" && "rtl",
            paddingLeft: 15,
            paddingRight: 15,
            paddingTop: 6,
            minHeight: 33,
            maxHeight: 33,
            paddingTop: 10,
            overflow: "hidden",
          }}
        >
          <span
            style={{
              fontWeight: 600,
            }}
          >
            <LocalOfferOutlinedIcon
              style={{
                paddingRight: language == "english" && 7,
                paddingLeft: language == "arabic" && 7,
                fontSize: 22,
              }}
            />
            {is_coupon
              ? promo.code
              : language == "english"
              ? promo.name
              : promo.ar_name}
          </span>
        </div>
        {promo.show_remaining && (
          <div
            style={{
              textAlign: language == "english" ? "left" : "right",
              direction: language == "arabic" && "rtl",
              paddingLeft: 37,
              paddingRight: 37,
              minHeight: 20,
              maxHeight: 33,
              overflow: "hidden",
              fontSize: "11px",
            }}
          >
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {language == "english"
                ? `This promotion can only be used ${promo.remaining} more times.`
                : `يمكن استخدام هذا العرض ${promo.remaining} مرات إضافية فقط`}
            </span>
          </div>
        )}
        {promo.show_expiry && (
          <div
            style={{
              textAlign: language == "english" ? "left" : "right",
              direction: language == "arabic" && "rtl",
              paddingLeft: 37,
              paddingRight: 37,
              minHeight: 20,
              maxHeight: 33,
              overflow: "hidden",
              fontSize: "11px",
            }}
          >
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {language == "english"
                ? `Expire in ${this.getExpiryDates(promo.expiry)} days`
                : `ينتهي خلال ${this.getExpiryDates(promo.expiry)} يوماً`}
            </span>
          </div>
        )}
        <div
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: language == "english" ? "Quicksand" : "Cairo",
            textAlign: language == "english" ? "left" : "right",
            paddingLeft: 15,
            paddingRight: 15,
            paddingTop: 5,
            minHeight: 80,
            maxHeight: 80,
            overflow: "hidden",
          }}
        >
          {promo.banner && (
            <img
              width={80}
              height={80}
              className={` mx-1 ${
                language === "english" ? "float-right" : "float-left"
              }`}
              src={promo.banner_small || promo.banner}
              data-was-processed="true"
            ></img>
          )}
          {this.getCouponText(promo, language)}
        </div>

        <div>
          <PromotionActionButton
            promo={promo}
            isCoupon={is_coupon}
            returnURL={"/"}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PromoItem);
